module.exports = __webpack_public_path__ + "img/Heng_Tao_Shen@2x.78bb718a.png";